import { render } from "./PcDisplayIcon.vue?vue&type=template&id=157d1c89"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__